import { render, staticRenderFns } from "./freeOrderManagement.vue?vue&type=template&id=19507158"
import script from "./freeOrderManagement.vue?vue&type=script&lang=js"
export * from "./freeOrderManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports